import 'ant-design-vue/lib/style/index.less' // antd core styles
import './components/kit/vendors/antd/themes/default.less' // default theme antd components
import './components/kit/vendors/antd/themes/dark.less' // dark theme antd components
import './global.scss' // app & third-party component styles
import './antd'
import './registerServiceWorker'
import './services/axios/fakeApi' // mocking api
import LoadScript from 'vue-plugin-load-script'

import App from './App.vue'
import { Basic } from './plugins'
import BootstrapVue from 'bootstrap-vue'
import NProgress from 'vue-nprogress'
import Vue from 'vue'
import VueCookies from 'vue-cookies'
import VueLayers from 'vuelayers'
import VuePageTitle from 'vue-page-title'
import { i18n } from './localization'
import mixins from './mixins'
import moment from 'vue-moment'
import router from './router'
import store from './store'

Vue.use(LoadScript)
Vue.use(Basic)
Vue.use(moment)
Vue.use(VueCookies)
Vue.use(BootstrapVue)
Vue.use(VueLayers)
Vue.use(NProgress)
Vue.use(VuePageTitle, {
  prefix: 'Reno SMS Dashboard | ',
  router,
})

// root mixins
Vue.mixin(mixins)

Vue.config.productionTip = false
const nprogress = new NProgress({ parent: 'body' })

new Vue({
  router,
  store,
  nprogress,
  i18n,
  render: (h) => h(App),
}).$mount('#app')
